import { FC } from 'react'
import * as styles from 'components/features/pfm/CategoryBreakdown/BreakdownChart.styl'
import { CommonChartValues } from 'interfaces/chart'
import { BarBreakdown } from 'components/features/pfm/CategoryBreakdown/BarBreakdown'
import cn from 'classnames'

type BreakdownChartProps = {
  amount: CommonChartValues
  projected?: CommonChartValues
  maxTotal: number
  withComparison: boolean
}

export const BreakdownChart: FC<BreakdownChartProps> = (props) => {
  const { amount, projected, maxTotal, withComparison } = props

  return (
    <div className={ cn(styles.breakdownChart, !withComparison && styles.hideComparison) }>
      <div className={ styles.bar }>
        <BarBreakdown amount={ amount.memberValue } projected={ projected ? projected.memberValue : null } max={ maxTotal } theme='member' />
      </div>
      <div className={ cn(styles.bar, styles.comparison) }>
        <BarBreakdown amount={ amount.peerValue } projected={ projected ? projected.peerValue : null } max={ maxTotal } theme='peers' />
      </div>
      <div className={ cn(styles.bar, styles.comparison) }>
        <BarBreakdown amount={ amount.otherValue } projected={ projected ? projected.otherValue : null } max={ maxTotal } theme='others' />
      </div>
    </div>
  )
}
